@if (!navigationHidden) {
  @if (navigationModel.visibleMainNav) {
    <app-navigation-view
      [links]="links"
      >
      <app-nav-item-account custom-links-top-level-1></app-nav-item-account>
      <app-nav-item-account custom-links-top-level-2></app-nav-item-account>
      <app-nav-item-logout custom-links-bottom-level-1></app-nav-item-logout>
    </app-navigation-view>
  }
  @if (navigationModel.localNavigation && !navigationModel.visibleMainNav) {
    <app-navigation-local-view
      [backLink]="navigationModel.localNavigation.backLink"
      [quickLink]="navigationModel.localNavigation.quickLink"
      [title]="navigationModel.title"
    ></app-navigation-local-view>
  }
  @if (navigationModel.localNavigation && navigationModel.visibleMainNav) {
    <app-navigation-local-view
      [backLink]="navigationModel.localNavigation.backLink"
      [isSubMenu]="true"
      [quickLink]="navigationModel.localNavigation.quickLink"
      [title]="navigationModel.title"
    ></app-navigation-local-view>
  }
}